// Next sort after a click on a sortable column (DataTable headers).
// First click sorts ascending, the second descending. With a defaultSort on another
// key the third click returns to it; otherwise the column flips back to ascending.
export function nextSort(current, key, defaultSort) {
  const onThis = !!current && current.key === key
  if (onThis && current.dir === 'desc' && defaultSort && defaultSort.key !== key) {
    return { key: defaultSort.key, dir: defaultSort.dir }
  }
  return { key, dir: onThis && current.dir === 'asc' ? 'desc' : 'asc' }
}
